import styled from 'styled-components';
import { DropDownButton } from '@pearsontechnology/aero-components';

export const InputWrapper = styled.div`
  display: grid;
  grid-gap: 6px;
`;

export const ColorDropDown = styled(DropDownButton)`
  transition: box-shadow 0.3s ease;
  box-shadow: 0 0 0 1px ${(props) => props.theme['color.input.border']};
`;

export const InputLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme['color.text.body']};
`;
